module.exports = __webpack_public_path__ + "media/images/weather/86_day-fc616d09c5c9e36b64ed8aa3be2086a9.png";